import { compose } from 'recompose';

import intlEquipped from '../../../../../hocs/intlEquipped';
import DefaultDetailsContent from './DefaultDetailsContent';

export default compose(
    intlEquipped
)(DefaultDetailsContent);
